import React from "react";
import useSecureLogin from "../../hooks/useSecureLogin";
import Loader from "../orderStatus/Loader";
const SecureLogin = () => {
    const {
        errorMessage = null,
        prosuiteDetails,
        t,
        loading,
        isFileOpenedfromTT,
        fileID
    } = useSecureLogin();

    return (
        <>
            <div className="min-h-screen-80">
                <div className="pt-10">
                    {errorMessage === null && (
                        <div
                            className="ml-2 font-semibold text-secondary-red mt-10"
                            data-cy="resetPasswordInvalidRequest"
                        >
                            Secure Loging in...
                        </div>
                    )}
                    {errorMessage !== null && (
                        <div
                            className="ml-2 font-semibold text-secondary-red mt-10"
                            data-cy="resetPasswordInvalidRequest"
                        >
                            {" "}
                            {errorMessage}
                        </div>
                    )}

                </div>

            </div>
            {loading ? <Loader /> : ""}
        </>
    );
};

export default SecureLogin;
